import { Injectable } from '@angular/core';

import { SiteSidenavRefBase } from './site-sidenav-ref-base';

@Injectable({ providedIn: 'root' })
export class SiteEndSidenavRef extends SiteSidenavRefBase {}
